import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/privacy-policy/client/PrivacyPolicyClient.tsx");
